type SetFormValue = (name: string, value: unknown, options?: { shouldValidate?: boolean }) => void;

/** Clears everything that depends on the selected ad account. */
export const clearTwitterDownstreamSelections = (setValue: SetFormValue): void => {
  setValue('selectedCampaigns', []);
  setValue('selectedLineItems', []);
  setValue('adSettings', {});
  setValue('$lineItemsData', []);
  setValue('$adSettingsData', undefined);
};
